<style lang="scss" scoped>
.slide-15 {
  background-image: url(../../../assets/module4/slide15/bg-06.jpg);
  background-position: center;
  background-size: cover;
  background-color: #fff;
  padding-top: 60px;
  height: calc(100% - 60px);
  padding-left: 70px;
}
h1 {
  color: #f8dc61;
  font-size: 193px;
  line-height: 232px;
  transform: rotate(-4deg);
}
h2 {
  font-size: 58px;
  line-height: 69px;
  transform: rotate(-4deg);
  margin-top: -0.75em;
  margin-left: -20px;
}
.chars {
  z-index: 1;
}
.close {
  position: absolute;
  width: 100px;
  right: 10px;
  bottom: 10px;
}
.left {
  width: 605px;
  margin-top: 50px;
  margin-left: 80px;
  p {
    line-height: 40px;
    color: white;
  }
}
.flex {
  justify-content: space-between;
}
.right {
  width: 561px;
  margin-right: 30px;
}
h3 {
  font-size: 34px;
  color: #f8dc61;
  width: 113%;
  text-align: center;
  &:first-of-type {
    margin-top: 33px;
  }
  .w {
    color: white;
  }
  .big {
    display: inline-block;
    font-size: 82px;
    transform: rotate(-5deg);
  }
  .big2 {
    display: inline-block;
    font-size: 59px;
    transform: none;
  }
}
a {
  margin-top: 30px;
  display: block;
  color: white;
  text-decoration: none;
  font-size: 34px;
  text-align: center;
}
h4 {
  font-size: 58px;
  text-align: center;
  .r {
    text-align: left;
    display: block;
    color: #aa252c;
  }
}
.test {
  transition: all 0.2s ease-out;
  display: block;
  width: 350px;
  position: absolute;
  bottom: 100px;
  right: 200px;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
.hand {
  left: 1125px;
}
</style>

<template>
  <div class="slide-15">
    <a href="/questionaire/" class="test">
      <img src="@/assets/module4/slide15/parent_test_btn.svg" />
    </a>
    <transition name="fadeUp" appear>
      <img
        src="@/assets/module4/slide15/sophia-06.png"
        class="chars delay-3"
        v-show="slideIndex == 14"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        src="@/assets/module4/slide15/hand-06.png"
        class="chars delay-8 hand"
        v-show="slideIndex == 14"
      />
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 14">
        <h1>Congratulations</h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 14" class="delay-1">
        <h2>You are a super cool FAST Hero!</h2>
      </div>
    </transition>
    <div class="flex">
      <transition name="fadeLeft" appear>
        <div class="left delay-2" v-show="slideIndex == 14">
          <p>
            And have completed part 4 of the FAST Hero Mission. Just one more to
            go and you will have graduated from the FAST Academy and will be a
            full qualified FAST Hero!
          </p>
          <h3>
            <span class="big">BUT</span>
            BEFORE YOU CAN START THE FINAL PART OF YOUR MISSION WE NEED TO
          </h3>
          <h3>
            <span class="w">
              TEST IF
              <span class="big2">YOUR PARENTS</span>
              HAVE BEEN LISTENING AS WELL!
            </span>
            SO PLEASE ASK THEM TO CLICK ON THIS LINK TO SHOW US WHAT THEY HAVE
            LEARNED.
          </h3>
        </div>
      </transition>
      <transition name="fadeRight" appear>
        <div class="right delay-2" v-show="slideIndex == 14">
          <h4>
            Bye FAST Heroes! <span class="r">don’t forget</span> TOGETHER WE CAN
            save the WORLD “One Grandhero at a time!”
          </h4>
        </div>
      </transition>
    </div>
    <img
      @click.prevent="reload()"
      class="close"
      src="@/assets/module1/slide27/button_close.png"
    />
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  methods: {
    reload() {
      window.location = "/e-books/";
    }
  }
};
</script>
